import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	user: {},
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUser: (state, action) => {
			state.user = action.payload;
		},

	},
});

// Экспорты экшенов и редьюсера
export const userActions = userSlice.actions;
export default userSlice.reducer;
